import React, { Component } from 'react'

class OptionVariantField extends Component {
  render () {
    let {variants, formValues, input, formIndexKey} = this.props

    let eachFormItemValue = formValues && formValues.items[formIndexKey].name
    let optVariants = variants && variants[eachFormItemValue]

    return <div>
      <select {...input} className='form-control' disabled={!optVariants || optVariants.length === 1}>
        {optVariants
        ? optVariants.map((val, key) => {
          return <option key={key} value={val}>
            {val}
          </option>
        })
        : <option value='no variant' disabled selected='no variant'>
            Variant Options
          </option>
      }
      </select>
    </div>
  }
}

OptionVariantField.propTypes = {
  variants: React.PropTypes.array
}

export default (OptionVariantField)



// WEBPACK FOOTER //
// ./app/components/Fields/ReduxForm/OptionVariantField/OptionVariantField.js